import React from "react";
import LocalDateTime from "services/date-converter";
import Chip from "../../../components/Chip";
import StatusPill from "../../components/StatusPill";
import { RUN_SOURCE_LABEL, RUN_STATUS } from "../../features/monitor.constants";
import { durationText } from "../../features/monitor.utils";

// Columns of the Run log list. `start` is the row number offset of the current page.
export const getRunLogColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "rule_fid",
    label: "Rule",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.rule?.name ?? `Rule #${row.rule_fid}`}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.rule?.code}</span>
      </div>
    ),
  },
  { key: "source", label: "Started by", sortable: true, render: (row) => <span className="text-xs text-text_secondary">{RUN_SOURCE_LABEL[row.source] ?? row.source}</span> },
  {
    key: "status",
    label: "Status",
    sortable: true,
    render: (row) => (
      <div className="flex flex-col items-start gap-0.5">
        <StatusPill status={row.status} map={RUN_STATUS} />
        {row.error_message && <span className="max-w-56 truncate text-[10px] text-text_muted" title={row.error_message}>{row.error_message}</span>}
      </div>
    ),
  },
  {
    key: "candidates",
    label: "Result",
    sortable: true,
    render: (row) =>
      row.source === "TEST" ? (
        <span className="text-xs text-text_muted">Preview only</span>
      ) : (
        <div className="flex flex-wrap gap-1">
          <Chip>{row.candidates} found</Chip>
          <Chip tone={row.opened ? "brand" : "default"}>{row.opened} opened</Chip>
          {row.resolved > 0 && <Chip>{row.resolved} resolved</Chip>}
          {row.dispatch_enqueued > 0 && <Chip>{row.dispatch_enqueued} sent</Chip>}
        </div>
      ),
  },
  { key: "duration_ms", label: "Took", sortable: true, render: (row) => <span className="text-xs text-text_secondary">{durationText(row.duration_ms)}</span> },
  { key: "started_at", label: "Started", sortable: true, render: (row) => <span className="text-xs text-text_secondary"><LocalDateTime utcTime={row.started_at} /></span> },
];
